export const theLocationData = {
  sections: [
    {
      title: "Amenities",
      block: [
        {
          headline: "Challenging the way we build homes",
          body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos.",
          img: {
            id: "671b6c8a6536c7a47560a0bb",
            publicURL:
              "https://luna.vmistudio.com/api/galleryMedia/get/gym.jpg",
            filename: "gym.jpg",
            mimeType: "image/jpeg",
            filesize: 13674711,
            width: 7680,
            height: 4320,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-25T10:01:46.787Z",
            updatedAt: "2024-10-25T10:01:46.787Z",
            url: "https://luna.vmistudio.com/api/galleryMedia/file/gym.jpg",
            thumbnailURL: null,
          },
          id: "671b6be08844e00026fe98fe",
        },
        {
          headline: "Creating a Vibrant community",
          body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL:
              "https://luna.vmistudio.com/api/galleryMedia/get/lounge.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "https://luna.vmistudio.com/api/galleryMedia/file/lounge.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
      ],
    },
    {
      title: "Amenities",
      block: [
        {
          headline: "Where clear vision empowers lives.",
          body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos.",
          img: {
            id: "671b6c8a6536c7a47560a0bb",
            publicURL:
              "https://luna.vmistudio.com/api/galleryMedia/get/gym.jpg",
            filename: "gym.jpg",
            mimeType: "image/jpeg",
            filesize: 13674711,
            width: 7680,
            height: 4320,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-25T10:01:46.787Z",
            updatedAt: "2024-10-25T10:01:46.787Z",
            url: "https://luna.vmistudio.com/api/galleryMedia/file/gym.jpg",
            thumbnailURL: null,
          },
          id: "671b6be08844e00026fe98fe",
        },
        {
          headline: "More Designers",
          body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL:
              "https://luna.vmistudio.com/api/galleryMedia/get/lounge.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "https://luna.vmistudio.com/api/galleryMedia/file/lounge.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
      ],
    },
    {
      title: "Amenities",
      block: [
        {
          headline: "Working to improve the local area.",
          body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos.",
          grid: [
            {
              title: "Economic Development",
              body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos",
            },
            {
              title: "Social Improvement",
              body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos",
            },
            {
              title: "Community Empowerment",
              body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad liubia nostra, per inceptos himenaeos",
            },
          ],
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL:
              "https://luna.vmistudio.com/api/galleryMedia/get/lounge.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "https://luna.vmistudio.com/api/galleryMedia/file/lounge.webp",
            thumbnailURL: null,
          },
          id: "671b6be08844e00026fe98fe",
        },
      ],
    },
  ],
}
